import Vue from 'vue'
import Vuex from 'vuex'
import {mutations} from '../store/mutations'
import {actions} from '../store/actions'
import {getters} from '../store/getters'

Vue.use(Vuex)

export const state = {
  /** API **/
  apiKey: '',

  /** Error **/
  registerError: false,
  registerErrorText: '',

  /** Form **/
  formData: {},
  apiError: undefined,
  apiErrorText: undefined,

  /** Loading spinner **/
  isLoading: false,
}

const store = {
  strict: false,
  state,
  mutations,
  actions,
  getters,
}

const vuexStore = new Vuex.Store(store)

export default vuexStore
